export const AVATARS = [
  {
    id: "monkey",
    name: "Momo",
    url: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/92916d2d98292c7fc1450c48fc9e5f201050edbc54c9859c6359d2a0143f168b.png",
  },
  {
    id: "owl",
    name: "Bubú",
    url: "/bubu_giraffe.jpg",
  },
  {
    id: "robot",
    name: "Bito",
    url: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/f0fbe21e9ab6ba6e8f3e484d01a5287bf696c8ced371edda2d388afad5b7684b.png",
  },
  {
    id: "dino",
    name: "Rex",
    url: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/51a40ea97c885b7a07c0140166d451d62987b813a5c88e7e8a9709f21049cde1.png",
  },
];

export const MEDAL_IMAGES = {
  gold: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/7be869ce4ea86aa76b77bb7f5969a2ec94ad2d830efe0e2da61bf9235b3d434f.png",
  silver: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/02f874cbbeb4436d11f74ff2bb5d0b1d20c8846ca0b4d62e9ac91be70e3be6a5.png",
  bronze: "https://static.prod-images.emergentagent.com/jobs/d4d38ee6-b77c-492f-bbad-a2ed0d95d4d0/images/ab846b9491184222600dcdd9fbb87709a51b43c55c14532511f8f03b4f9330d7.png",
};

export const OPERATIONS = [
  {
    id: "suma",
    name: "Suma",
    symbol: "+",
    color: "#FF3B30",
    colorLight: "#FFE5E3",
    borderDark: "#B22A22",
    description: "Junta números",
  },
  {
    id: "resta",
    name: "Resta",
    symbol: "−",
    color: "#007AFF",
    colorLight: "#E0F0FF",
    borderDark: "#0056B3",
    description: "Quita números",
  },
  {
    id: "multiplicacion",
    name: "Multiplicación",
    symbol: "×",
    color: "#32ADE6",
    colorLight: "#DFF3FB",
    borderDark: "#1F7BA8",
    description: "Veces y veces",
  },
  {
    id: "division",
    name: "División",
    symbol: "÷",
    color: "#E0A800",
    colorLight: "#FFF6D5",
    borderDark: "#A07800",
    description: "Reparte en partes",
  },
  {
    id: "porcentajes",
    name: "Porcentajes",
    symbol: "%",
    color: "#AF52DE",
    colorLight: "#F1E2FA",
    borderDark: "#7E36A8",
    description: "Partes de 100",
  },
  {
    id: "fracciones",
    name: "Fracciones",
    symbol: "½",
    color: "#EC4899",
    colorLight: "#FCE7F3",
    borderDark: "#9D174D",
    description: "Partes de un todo",
  },
  {
    id: "decimales",
    name: "Decimales",
    symbol: ".5",
    color: "#10B981",
    colorLight: "#D1FAE5",
    borderDark: "#065F46",
    description: "Números con punto",
  },
];

export const LEVELS = [
  { id: "facil", name: "Fácil", stars: 1, points: 5, color: "#34C759" },
  { id: "medio", name: "Medio", stars: 2, points: 10, color: "#FF9500" },
  { id: "dificil", name: "Difícil", stars: 3, points: 20, color: "#FF3B30" },
];

export const FRACTION_SUB_OPS = [
  {
    id: "suma",
    name: "Suma de fracciones",
    short: "Suma",
    symbol: "+",
    color: "#FF3B30",
    colorLight: "#FFE5E3",
    borderDark: "#B22A22",
    description: "Juntar fracciones",
  },
  {
    id: "resta",
    name: "Resta de fracciones",
    short: "Resta",
    symbol: "−",
    color: "#007AFF",
    colorLight: "#E0F0FF",
    borderDark: "#0056B3",
    description: "Quitar fracciones",
  },
  {
    id: "multiplicacion",
    name: "Multiplicación de fracciones",
    short: "Multiplicación",
    symbol: "×",
    color: "#32ADE6",
    colorLight: "#DFF3FB",
    borderDark: "#1F7BA8",
    description: "Multiplicar fracciones",
  },
  {
    id: "division",
    name: "División de fracciones",
    short: "División",
    symbol: "÷",
    color: "#E0A800",
    colorLight: "#FFF6D5",
    borderDark: "#A07800",
    description: "Dividir fracciones",
  },
  {
    id: "simplificacion",
    name: "Simplificación de fracciones",
    short: "Simplificación",
    symbol: "⤳",
    color: "#9D4EDD",
    colorLight: "#F0E4FF",
    borderDark: "#6B21A8",
    description: "Reducir a mínima expresión",
  },
];

export function getFractionSubOp(id) {
  return FRACTION_SUB_OPS.find((s) => s.id === id);
}

export const DECIMAL_SUB_OPS = [
  {
    id: "suma",
    name: "Suma de decimales",
    short: "Suma",
    symbol: "+",
    color: "#FF3B30",
    colorLight: "#FFE5E3",
    borderDark: "#B22A22",
    description: "Sumar con punto",
  },
  {
    id: "resta",
    name: "Resta de decimales",
    short: "Resta",
    symbol: "−",
    color: "#007AFF",
    colorLight: "#E0F0FF",
    borderDark: "#0056B3",
    description: "Restar con punto",
  },
  {
    id: "multiplicacion",
    name: "Multiplicación de decimales",
    short: "Multiplicación",
    symbol: "×",
    color: "#32ADE6",
    colorLight: "#DFF3FB",
    borderDark: "#1F7BA8",
    description: "Multiplicar con punto",
  },
];

export function getDecimalSubOp(id) {
  return DECIMAL_SUB_OPS.find((s) => s.id === id);
}

export const SECUNDARIA_TOPICS = [
  {
    id: "algebra",
    name: "Álgebra básica",
    short: "Álgebra",
    description: "Ecuaciones y polinomios",
    color: "#7B61FF",
    colorLight: "#E9E3FF",
    borderDark: "#3D2EA0",
    icon: "Sigma",
    available: true,
    target: "/secundaria/algebra",
  },
  {
    id: "geometria",
    name: "Geometría",
    short: "Geometría",
    description: "Perímetros, áreas, Pitágoras y ángulos",
    color: "#10B981",
    colorLight: "#D1FAE5",
    borderDark: "#065F46",
    icon: "Triangle",
    available: true,
    target: "/secundaria/geometria",
  },
];

export function getSecundariaTopic(id) {
  return SECUNDARIA_TOPICS.find((t) => t.id === id);
}

export const GEOMETRIA_SUB_OPS = [
  {
    id: "perimetros",
    name: "Perímetros",
    short: "Perímetros",
    symbol: "P",
    color: "#FF9500",
    colorLight: "#FFEEDC",
    borderDark: "#B05A00",
    description: "Suma los lados de la figura",
    sample: "Cuadrado, rectángulo, círculo",
  },
  {
    id: "areas",
    name: "Áreas",
    short: "Áreas",
    symbol: "A",
    color: "#10B981",
    colorLight: "#D1FAE5",
    borderDark: "#065F46",
    description: "Superficie de una figura",
    sample: "base × altura, π·r²",
  },
  {
    id: "pitagoras",
    name: "Teorema de Pitágoras",
    short: "Pitágoras",
    symbol: "△",
    color: "#7B61FF",
    colorLight: "#E9E3FF",
    borderDark: "#3D2EA0",
    description: "a² + b² = c²",
    sample: "Hipotenusa y catetos",
  },
  {
    id: "angulos",
    name: "Ángulos",
    short: "Ángulos",
    symbol: "∠",
    color: "#FF3B30",
    colorLight: "#FFE5E3",
    borderDark: "#B22A22",
    description: "Complementarios, suplementarios, triángulos",
    sample: "Suma 90°, 180° o 360°",
  },
];

export function getGeometriaSubOp(id) {
  return GEOMETRIA_SUB_OPS.find((s) => s.id === id);
}

export const ALGEBRA_SUB_OPS = [
  {
    id: "ecuaciones",
    name: "Ecuaciones de primer grado",
    short: "Ecuaciones",
    symbol: "x =",
    color: "#7B61FF",
    colorLight: "#E9E3FF",
    borderDark: "#3D2EA0",
    description: "Encuentra el valor de x",
    sample: "2x + 5 = 11",
  },
  {
    id: "polinomios_suma",
    name: "Suma de polinomios",
    short: "Suma",
    symbol: "+",
    color: "#FF3B30",
    colorLight: "#FFE5E3",
    borderDark: "#B22A22",
    description: "Suma términos algebraicos",
    sample: "(3x + 2) + (5x − 1)",
  },
  {
    id: "polinomios_resta",
    name: "Resta de polinomios",
    short: "Resta",
    symbol: "−",
    color: "#007AFF",
    colorLight: "#E0F0FF",
    borderDark: "#0056B3",
    description: "Resta términos algebraicos",
    sample: "(5x − 4) − (2x + 3)",
  },
  {
    id: "monomios_multi",
    name: "Multiplicación de monomios",
    short: "Multiplicación",
    symbol: "×",
    color: "#32ADE6",
    colorLight: "#DFF3FB",
    borderDark: "#1F7BA8",
    description: "Multiplica monomios",
    sample: "2x × 3x²",
  },
];

export function getAlgebraSubOp(id) {
  return ALGEBRA_SUB_OPS.find((s) => s.id === id);
}

export const QUESTIONS_PER_ROUND = 10;

export function getOperation(id) {
  return OPERATIONS.find((o) => o.id === id);
}

export function getLevel(id) {
  return LEVELS.find((l) => l.id === id);
}

export function getAvatar(id) {
  return AVATARS.find((a) => a.id === id);
}
